<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          ติดตามความก้าวหน้า (รายเดือน)
        </div>
        <div class="d-flex align-center font-type-bold txt-head black--text">
          <Iconify
              icon="ci:list-checklist"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          <div>โครงการที่ได้รับการอนุมัติ</div>
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
                @onChange="searchData.keyword = $event"
                @onEnter="getFormAList()"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end">
<!--          <Button-->
<!--              @onClick="createProject"-->
<!--          >-->
<!--            สร้างโครงการ-->
<!--          </Button>-->
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <RSPMonthlyProgressItem
            v-for="(item, i) in formAList"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
        ></RSPMonthlyProgressItem>
      </div>

      <v-pagination
          class="mt-6"
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          @input="getFormAList"
      ></v-pagination>

    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import Button from "../../components/input/Button"
import SelectBox from "../../components/input/SelectBox"
import RSPMonthlyProgressItem from "../../components/RSPMonthlyProgressItem.vue"

export default {
  name: "RSPMonthlyProgressList",
  components: {
    TextField,
    SelectBox,
    RSPMonthlyProgressItem,
    Button
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '8%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'ปี งปม.',
          width: '8%'
        },
        {
          name: 'ชื่อโครงการหลัก',
          width: '45%'
        },
        {
          name: 'ภูมิภาค',
          width: '12%'
        },
        {
          name: 'สถานะ',
          width: '11%'
        },
        {
          name: '',
          width: '10%'
        }
      ],
      formAList: [],
      searchData: {
        status: null,
        keyword: null
      },
      statusMaster: [
          'Draft',
          'Submitted1',
          'Inception',
          'Submitted2',
          'Approved',
      ],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    }
  },
  created () {
    this.getFormAList()
  },
  methods: {
    createProject () {
      this.$router.push({ name: 'MainProjectForm' })
    },
    async getFormAList (page) {
      let payload = {
        page: page,
        status: 'Approved',
        form_type: 'D',
        keyword: this.searchData.keyword
      };

      let res
      res = await this.$apiFire('AForm/getFormAList', payload)
      console.log(res)
      console.log(res.data)
      this.formAList = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1
        }
      });
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
    }
  }
}
</script>

<style scoped>
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>